import React from "react";

function Sponsors() {
  return (
    <div className="sponsors">
      <div className="sponsor-logo">
        <img src="imgs/HFA.png" alt="HFA Logo" />
      </div>
      <div className="sponsor-logo">
        <img src="imgs/LIQ_Logo_06.png" alt="LIQ Logo" />
      </div>
    </div>
  );
  
}

export default Sponsors;
